module.exports = __webpack_public_path__ + "static/media/swaziland-flag-round-small.48b43c0c.jpg";